"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopTracking = exports.restartTracking = exports.anonymizeUser = exports.identifyUser = exports.init = void 0;
var FullStory = require("@fullstory/browser");
function init(options, cb) {
    FullStory.init(options, cb);
}
exports.init = init;
function identifyUser(userId, userData) {
    FullStory.identify(userId, userData);
}
exports.identifyUser = identifyUser;
function anonymizeUser() {
    FullStory.anonymize();
}
exports.anonymizeUser = anonymizeUser;
function restartTracking() {
    FullStory.restart();
}
exports.restartTracking = restartTracking;
function stopTracking() {
    FullStory.shutdown();
}
exports.stopTracking = stopTracking;
